import React from "react";
import me from "../../assets/images/me.png";

function AboutPreviewSection() {
  return (
    <section
      id="about"
      className="bg-transparent p-4 sm:p-8 font-sans border-t border-slate-900/10 mt-12"
    >
      <div className="mx-auto max-w-7xl w-full">
        {/* Kontainer Utama Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Sisi Kiri: Frame Foto Personal Neo-Brutalisme (Mengambil Inspirasi Referensi) */}
          <div className="lg:col-span-5 flex justify-center lg:justify-start py-4">
            <div className="relative group">
              {/* Bingkai Luar Putus-putus */}
              <div className="absolute -inset-4 border-2 border-dashed border-slate-400 rounded-3xl transform rotate-1 scale-105 pointer-events-none group-hover:rotate-3 transition-transform duration-300"></div>

              {/* Kontainer Foto Utama - Menggunakan Shadow Moss -> Bronze */}
              <div className="relative border-2 border-slate-900 bg-white rounded-2xl p-2.5 w-72 sm:w-80 overflow-hidden shadow-[8px_8px_0px_0px_#ccd5ae] transition-all duration-300 group-hover:-translate-y-1 group-hover:shadow-[12px_12px_0px_0px_#d4a373]">
                <div className="aspect-[4/5] w-full bg-slate-100 rounded-xl overflow-hidden border border-slate-900/10 transition-all duration-500">
                  {/* Gunakan file foto portrait personal Anda di sini */}
                  <img
                    src={me}
                    alt="Gugun Jofandi"
                    className="w-full h-full object-cover transition-all duration-500"
                  />
                </div>

                {/* Badge Status Melayang di Pojok Bawah */}
                <div className="absolute bottom-5 -right-2 border-2 border-slate-900 bg-white px-3 py-1.5 rounded-lg transform rotate-2 shadow-[2px_2px_0px_0px_#slate-900] max-w-[180px]">
                  <p className="text-[10px] font-black text-slate-900 uppercase leading-none tracking-tight">
                    Available for Global Opportunities 🌏
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Sisi Kanan: Konten Teks (2 Paragraf) & Navigasi */}
          <div className="lg:col-span-7 space-y-6">
            <div>
              <span className="text-xs font-bold uppercase tracking-widest text-gsf-bronze">
                Behind the Systems
              </span>
              <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mt-1 tracking-tight">
                About Gunjo
              </h2>
            </div>

            {/* Paragraf 1: Sisi Profesional & Pendidikan */}
            <p className="text-base text-slate-600 font-medium leading-relaxed">
              I'm a Software Engineer focused on building production-ready
              applications that solve real business problems. My experience
              spans backend engineering, enterprise software, scalable system
              architecture, and full-stack development, with a strong emphasis
              on reliability, maintainability, and long-term product growth.
            </p>

            {/* Paragraf 2: Sisi Personal & Peran Sebagai Educator */}
            <p className="text-base text-slate-600 font-medium leading-relaxed">
              With an academic background in Electrical Engineering and a
              master's degree in Informatics specializing in Data Science &
              Artificial Intelligence, I enjoy bridging software engineering
              with intelligent technologies. I'm passionate about designing
              systems that are not only scalable and efficient, but also
              practical for real-world users and organizations.
            </p>

            {/* Link Action: Read More */}
            <div className="pt-2">
              <a
                href="/about"
                className="inline-flex items-center gap-2 border-2 border-slate-900 bg-slate-900 px-6 py-3 font-bold text-xs uppercase tracking-wider text-white rounded-xl shadow-[4px_4px_0px_0px_#faedcd] transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[6px_6px_0px_0px_#d4a373] active:translate-y-0"
              >
                Explore My Journey <span>→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutPreviewSection;
